import React, { lazy } from "react";
import SmoothScroll from "./SmoothScroll/SmoothScroll"; // ۱. کامپوننت را وارد کنید

// Layouts and Guards - Direct import
import ProtectedRoute from "LoginForm/ProtectRouter/ProtectRouter";
import LoginRedirectGuard from "LoginForm/LoginRedirectGuard/LoginRedirectGuard";
import PageError404 from "./PageNoteFound/PageError404";


// Lazy-loaded page components
const Index = lazy(() => import("./Pages/Index/Index"));
const Employer = lazy(() => import("./Employer/Employer"));
const EmployerLayout =lazy(()=> import( "./Employer/EmployerLayout")); // ✅ وارد کردن لایوت جدید
const LoginForm = lazy(() => import("./LoginForm/LoginForm"));
const AboutUs = lazy(()=> import("Pages/AboutUs/AboutUs"))
const ProjectsDetails = lazy(() =>
  import("./Components/ProjectsDetails/ProjectsDetails")
);
const ServicesList = lazy(() =>
  import("./Components/ServicesList/ServicesList")
);
const AllProjectList = lazy(() =>
  import("./Components/AllProjectList/AllProjectList")
);
const AttriModal = lazy(() => import("Employer/AttriModal/AttriModal"));
const MeetingView = lazy(() => import("Employer/MeetingPage/MeetingView"));
const ContractView = lazy(() => import("Employer/ContractPage/ContractView"));
const GalleryPage = lazy(()=> import ("Employer/GalleryPage/GalleryPage"))
const Routers = [
  // ۲. فقط این خط را تغییر دهید
  {
    path: "/",
    element: (
      <SmoothScroll>
        <Index />
      </SmoothScroll>
    ),
  },
  { path: "/projects/:id", element: <ProjectsDetails /> },
  {path : "/aboutUs" , element:<AboutUs/>},
  { path: "/services", element: <ServicesList /> },
  { path: "/allProjectList", element: <AllProjectList /> },
  {
     path: "/employer",
    element: (
      <ProtectedRoute>
        <EmployerLayout />
      </ProtectedRoute>
    ),

    children: [
      {index:true, element: <Employer /> },
      
      { path: "/employer/attributes/:id/:name", element: <AttriModal /> }, // ✅ اصلاح شده
      { path: "/employer/meetings/:id", element: <MeetingView /> },
      { path: "/employer/contract/:id", element: <ContractView /> },
      { path: "/employer/gallery/:id", element: <GalleryPage />  },
    ],
    
  },
  {
    path: "/login",
    element: (
      <LoginRedirectGuard>
        <LoginForm />
      </LoginRedirectGuard>
    ),
  },
  { path: "*", element: <PageError404 /> },
];

export default Routers;
